import script from "./Effect.vue?vue&type=script&setup=true&lang=js"
export * from "./Effect.vue?vue&type=script&setup=true&lang=js"

import "./Effect.vue?vue&type=style&index=0&id=b20c1462&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b20c1462"]])

export default __exports__